import React, { useCallback } from 'react'

import { IconButton } from '@material-ui/core'
import { Close as CloseIcon } from '@material-ui/icons'
import { useSnackbar as useSnackbarIo } from 'notistack'

import { AUTOHIDE_DURATION_SNACKBAR } from '~/config/constants'

const useSnackbar = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbarIo()

  const openSnackbar = useCallback(
    (message, success, customMessage, id = '', options = {}) => {
      const resMesssage = message || customMessage
      const variant = success ? 'success' : 'error'
      enqueueSnackbar(resMesssage, {
        id,
        variant,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'center',
        },
        autoHideDuration: AUTOHIDE_DURATION_SNACKBAR,
        preventDuplicate: true,
        action: (
          <IconButton onClick={() => closeSnackbar()} size="small">
            <CloseIcon className="snack-icon" />
          </IconButton>
        ),
        ...options,
      })
    },
    []
  )

  return {
    openSnackbar,
  }
}

export default useSnackbar
